var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"text-left pt-10"},[(_vm.activeItem)?_vm._l((_vm.computedItems),function(item,index){return _c('data-input',{key:index,attrs:{"data-type":_vm.dataInputText,"value":item.value,"label":item.label,"readonly":""}})}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }